import { render } from "./SaveCompUser.vue?vue&type=template&id=f5226980&scoped=true"
import script from "./SaveCompUser.vue?vue&type=script&lang=js"
export * from "./SaveCompUser.vue?vue&type=script&lang=js"

import "./SaveCompUser.vue?vue&type=style&index=0&id=f5226980&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5226980"]])

export default __exports__